import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import {
  SlDrawer,
  SlButton,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { Controller, useForm } from "react-hook-form";
import { roles } from "../../utils/constants";
import PdfViewer from "./PdfViewer";
import { formatDate, formatDateYYYYMMDD } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import OrderPayment from "./OrderPayment";
import Select from "react-select";
import EditSvg from "../../assets/images/edit_icon.svg";
import closeSvg from "../../assets/images/minus.svg";
import ScrollContainer from "react-indiana-drag-scroll";
import config from "../../config";

function InvoiceUpdate(props) {
  const [file, setFile] = useState();
  const [invoiceData, setInvoiceData] = useState([]);
  const [fileUrl, setFileUrl] = useState("");
  const [addInvoice, setAddInvoice] = useState(false);
  const [viewPdf, setViewPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [invoiceId, setInvoiceId] = useState("");
  const [lineItems, setLineItems] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editInvoice, setEditInvoice] = useState(false);
  const [editData, setEditData] = useState({});
  const [spent, setSpent] = useState(0);

  const form1 = useForm({ mode: "onSubmit" });
  const handleRequestClose = (event) => {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  };

  const payments = {
    0: "Pending",
    1: "Partially Paid",
    2: "Finished",
    3: "Settlement",
  };

  const stages = {
    0: "",
    1: "Follow Up 1",
    2: "Follow Up 2",
    3: "Follow Up 3",
    4: "Legal 1",
    5: "Legal 2",
  };

  const handleClose = () => {
    props.setShow(false);
  };
  const handleClosePayment = () => {
    setShowPayment(false);
    setInvoiceId("");
  };

  const handleFileChangeInvoice = (e) => {
    if (e.target.files.length) {
      if (e.target.files[0].type === "application/pdf") {
        setFile(e.target.files[0]);
      } else {
        Toast("error", "Only pdf is allowed!");
        form1.setValue("file", "");
      }
    }
  };
  const formData = new FormData();
  formData.append("files", file);
  const uploaInvoiceFile = async () => {
    try {
      let res = await api({
        url: "/upload/file-upload",
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.code === 200) {
        setFileUrl(res.data?.data);
        setFile("");
        Toast("success", "Updated successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleInvoiceUpdate = async (data) => {
    setLoader(true);
    // console.log(data);
    if (editInvoice) {
      try {
        let res = await api({
          url: "/invoice/updateInvoice",
          method: "POST",
          responseType: "json",
          data: {
            invoice_no: data.invoice_no,
            reason: data.reason,
            order_id: props.order_id,
            credited_period: data.credit_period,
            invoice_url: fileUrl,
            lineitem_id: data.lineitems,
            generated_date: data.generated_date,
            amount: data.amount,
            gst:data.gst,
            id:invoiceId
          },
        });
        if (res.code === 200) {
          fetchData();
          form1.reset();
          setAddInvoice(false);
          setEditData({})
        } else {
          Toast("error", "Please try again!");
        }
        setLoader(false);
      } catch (error) {
        console.error(error);
      }
    } else {
      try {
        let res = await api({
          url: "/invoice/addInvoice",
          method: "POST",
          responseType: "json",
          data: {
            invoice_no: data.invoice_no,
            reason: data.reason,
            order_id: props.order_id,
            credited_period: data.credit_period,
            invoice_url: fileUrl,
            lineitem_id: data.lineitems,
            generated_date: data.generated_date,
            amount: data.amount,
            gst:data.gst
          },
        });
        if (res.code === 200) {
          fetchData();
          form1.reset();
          setAddInvoice(false);
        } else {
          Toast("error", "Please try again!");
        }
        setLoader(false);
      } catch (error) {
        console.error(error);
      }
    }
  };
  const fetchData = async () => {
    try {
      let res = await api({
        url: "/invoice/getInvoiceByOrderId",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
        },
      });
      if (res.code === 200) {
        setInvoiceData(res.data);
        console.log(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLineItems = async () => {
    try {
      let res = await api({
        url: "/order/fetch-line-items",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
        },
      });
      if (res.code === 200) {
        setLineItems(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (file) uploaInvoiceFile();
  }, [file]);

  const paymentStages = [
    { label: "Choose", value: "0" },
    { label: "Follow up 1", value: "1" },
    { label: "Follow up 2", value: "2" },
    { label: "Follow up 3", value: "3" },
    { label: "Legal 1", value: "4" },
    { label: "Legal 2", value: "5" },
  ];

  const handlePaymentStatus = async (
    e,
    order_id,
    invoice_id,
    from = "status"
  ) => {
    try {
      let res = await api({
        url: "/invoice/update-status",
        method: "POST",
        responseType: "json",
        data: {
          order_id: order_id,
          status: e.target.value,
          invoice_id: invoice_id,
          from,
        },
      });
      if (res.code === 200) {
        Toast("success", "Payment Status updated Successfully");
        fetchData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLineItemSpent = async (lineitem_id) => {
    try {
      let res = await api({
        url: "/invoice/fetch-line-item-spent",
        method: "POST",
        responseType: "json",
        data: {
          lineitem_id: lineitem_id,
        },
      });
      if (res.code === 200) {
        setSpent(res.data.spent);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const watchLineitems = form1.watch("lineitems", []);
  useEffect(() => {
    if (addInvoice && watchLineitems?.length) {
      fetchLineItemSpent(watchLineitems);
    }
  }, [watchLineitems]);
  useEffect(() => {
    if (editInvoice) {
      form1.setValue("invoice_no", editData.invoice_no);
      form1.setValue("reason", editData.reason);
      form1.setValue(
        "credit_period",
        Math.round((editData.credited_period - editData.invoice_date) / 86400)
      );
      form1.setValue(
        "generated_date",
        formatDateYYYYMMDD(editData.invoice_date)
      );
      form1.setValue("amount", editData.amount);
      form1.setValue("lineitems", editData.lineitems);
      form1.setValue("gst", `${editData.gst}`);
      setFileUrl(editData.invoice_url);
    }
  }, [editInvoice]);

  return (
    <>
      <SlDrawer
        label="Upload Invoice"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": "70%" }}
      >
        <div>
          {localStorage.getItem("role") === roles.financer && (
            <div className="d-flex justify-content-end">
              <SlButton
                variant="primary"
                size="small"
                onClick={() => {
                  setAddInvoice(true);
                  fetchLineItems();
                }}
              >
                Add Invoice
              </SlButton>
            </div>
          )}
          <ScrollContainer>
            <div>
              <h5>Invoice Records</h5>
              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Invoice No</th>
                    <th>Invoice Date</th>
                    <th>Due Date</th>
                    <th title="Invoice Amount">IA</th>
                    <th title="Amount Recovered">AR</th>
                    <th>Uploaded by</th>
                    <th>Reason</th>
                    <th>LineItems</th>
                    <th>Payment Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                {invoiceData?.length > 0 ? (
                  <tbody>
                    {invoiceData.map((item, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.invoice_no}</td>
                          <td>{formatDate(item.invoice_date)}</td>
                          <td>{formatDate(item.credited_period)}</td>
                          <td>{item.amount}</td>
                          <td>{item.total_payments}</td>
                          <td>{item.user}</td>
                          <td>{item.reason}</td>
                          <td>
                            {item.lineitems?.map((lineitem, index) => {
                              return (
                                <p key={index} className="my-0">
                                  {lineitem.label}
                                </p>
                              );
                            })}
                          </td>
                          <td>
                            {editIndex === item.invoice_no ? (
                              <>
                                <div className="d-flex gap-1 w-72">
                                  {item?.payment_status === 3 && (
                                    <>
                                      <label className="form-label">
                                        Stage
                                      </label>
                                      <select
                                        label="Stage"
                                        size="small"
                                        // className="form-select"
                                        value={`${item?.payment_stage}`}
                                        onChange={(e) => {
                                          handlePaymentStatus(
                                            e,
                                            props.order_id,
                                            item.id,
                                            "stage"
                                          );
                                        }}
                                      >
                                        {localStorage.getItem("role") ===
                                        roles.financer
                                          ? paymentStages
                                              .slice(0, 6)
                                              .map((item, index) => {
                                                return (
                                                  <option
                                                    key={item.value}
                                                    value={item.value}
                                                  >
                                                    {item.label}
                                                  </option>
                                                );
                                              })
                                          : paymentStages
                                              .slice(6)
                                              .map((item, index) => {
                                                return (
                                                  <option
                                                    key={item.value}
                                                    value={item.value}
                                                  >
                                                    {item.label}
                                                  </option>
                                                );
                                              })}
                                      </select>
                                    </>
                                  )}
                                  <img
                                    src={closeSvg}
                                    alt="close"
                                    className="cursor-pointer w-4"
                                    onClick={() => setEditIndex(null)}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="d-flex gap-3">
                                  <div>
                                    <p className="m-0">
                                      {payments[item.payment_status]}
                                    </p>

                                    <p className="m-0">
                                      {stages[item.payment_stage]}
                                    </p>
                                  </div>
                                  {item.payment_status === 3 ? (
                                    <img
                                      className="w-4 cursor-pointer"
                                      src={EditSvg}
                                      onClick={() => setEditIndex(item.invoice_no)}
                                      alt="pencil"
                                    ></img>
                                  ) : item.payment_status === 1 ? <SlButton variant="primary" size="small"  value={2} onClick={(e)=>{handlePaymentStatus(e, item.order_id, item.id)}}>
                                    TDS
                                  </SlButton> : null}
                                </div>
                              </>
                            )}
                          </td>
                          <td>
                            <div className="d-flex gap-3">
                              <SlIcon
                                onClick={() => {
                                  setPdfUrl(item.invoice_url);
                                  setViewPdf(true);
                                }}
                                className="hover:cursor-pointer hover:text-sky-400"
                                library="lucide"
                                name="eye"
                              ></SlIcon>
                              <SlIcon
                                onClick={() => {
                                  setShowPayment(true);
                                  setInvoiceId(item.id);
                                }}
                                name="indian-rupee"
                                library="lucide"
                                className="hover:cursor-pointer hover:text-sky-400"
                              ></SlIcon>
                              {
                                item.payment_status !== 2 ?
                              <SlIcon
                                onClick={() => {
                                  setEditInvoice(true);
                                  setAddInvoice(true);
                                  setInvoiceId(item.id);
                                  setEditData(item);
                                  fetchLineItems()
                                  fetchLineItemSpent(item.lineitems)
                                }}
                                name="pencil"
                                library="lucide"
                                className="hover:cursor-pointer hover:text-sky-400"
                              ></SlIcon> : null}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : loader ? (
                  <TableLoader colspan={5} />
                ) : null}
              </table>
            </div>
          </ScrollContainer>
          {addInvoice && (
            <div className="my-3 p-3 border rounded relative">
              <form onSubmit={form1.handleSubmit(handleInvoiceUpdate)}>
                <h6 className="mb-3">Add Invoice Record</h6>
                <div className="mb-3">
                  <label className="form-label">Invoice No</label>
                  <span className="text-red-600">*</span>
                  <input
                    type="text"
                    className="form-control"
                    {...form1.register("invoice_no", { required: true })}
                    placeholder="Enter Invoice No"
                  ></input>
                  {form1.formState?.errors?.invoice_no && (
                    <p className="text-red-600 text-sm mt-1">
                      Invoice No is required!
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Reason</label>
                  <input
                    className="form-control"
                    placeholder="Reason"
                    {...form1.register("reason", {
                      required: false,
                    })}
                  ></input>
                  {form1.formState?.errors?.reason && (
                    <p className="text-red-600 text-sm mt-1">
                      Reason is required!
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Invoice Date</label>
                  <input
                    className="form-control"
                    type="date"
                    {...form1.register("generated_date", { required: true })}
                  ></input>
                  {form1.formState?.errors?.generated_date && (
                    <p className="text-red-600 text-sm mt-1">
                      Invoice Date is required!
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Credit Period</label>
                  <span className="text-red-600">*</span>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter credit period"
                    {...form1.register("credit_period", { required: true })}
                  ></input>
                  {form1.formState?.errors?.credit_period && (
                    <p className="text-red-600 text-sm mt-1">
                      Credit Period is required!
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">LineItems - Spent - {spent}</label>
                  <span className="text-red-600">*</span>
                  <Controller
                    name="lineitems"
                    control={form1.control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        name="lineitems_"
                        isMulti
                        options={lineItems}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    )}
                  ></Controller>
                  {form1.formState?.errors?.lineitems && (
                    <p className="text-red-600 text-sm mt-1">
                      Lineitems is required!
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Amount</label>
                  <span className="text-red-600">*</span>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter Amount"
                    {...form1.register("amount", { required: true })}
                  ></input>
                  {form1.formState?.errors?.amount && (
                    <p className="text-red-600 text-sm mt-1">
                      Amount is required!
                    </p>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">GST</label><br/>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" {...form1.register("gst", {required:true})} defaultChecked={true} type="radio"  id="inlineRadio1" value={'true'} />
                    <label class="form-check-label" for="inlineRadio1">Include GST</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" {...form1.register("gst", {required:true})} id="inlineRadio2" value={'false'} />
                    <label class="form-check-label" for="inlineRadio2">Exclude GST</label>
                </div>
                  </div>
                <div className="mb-3">
                  <label>Upload Invoice</label>
                  <span className="text-red-600">*</span>
                  <input
                    type="file"
                    className="form-control"
                    accept="application/pdf"
                    {...form1.register("file", {
                      required: editInvoice ? false : true,
                      onChange: (e) => handleFileChangeInvoice(e),
                    })}
                  ></input>
                  {fileUrl && <p>{fileUrl}</p>}
                  {form1.formState?.errors?.file && (
                    <p className="text-red-600 text-sm mt-1">
                      Invoice is required!
                    </p>
                  )}
                </div>
                <div>
                  <SlButton
                    type="submit"
                    className="w-full"
                    variant="success"
                    size="small"
                  >
                    Submit
                  </SlButton>
                </div>
                <div
                  onClick={() => {
                    setAddInvoice(false);
                    form1.reset();
                    setEditData({});
                    setEditInvoice(false);
                    setFileUrl();
                  }}
                  className="text-red-400  hover:text-red-600 hover:cursor-pointer absolute top-1 right-3 transition-all ease-in-out"
                >
                  x
                </div>
              </form>
            </div>
          )}
        </div>
      </SlDrawer>
      {viewPdf && (
        <PdfViewer url={pdfUrl} show={viewPdf} setShow={setViewPdf} />
      )}
      {showPayment ? (
        <OrderPayment
          show={showPayment}
          setShow={handleClosePayment}
          order_id={props.order_id}
          orderName={props.order_name}
          invoice_id={invoiceId}
          loadData={fetchData}
        />
      ) : null}
    </>
  );
}

export default InvoiceUpdate;
